import { resolveCameraProximityOpacity } from './cameraProximity.js';
import { resolveFlagTextOpacity, resolveLabelProximityOpacity } from './labelProximity.js';
export function resolveLabelRenderPlan(label) {
    const width = Math.max(1, label.text.length) * label.fontSize * 0.62 + label.padding * 2;
    const height = label.fontSize + label.padding * 2;
    const post = label.flag?.postOffset;
    const postTopScale = post ? -height / (2 * (Math.hypot(...post) || 1)) : 0;
    const textRenderOrder = label.renderOrder === null ? undefined : label.renderOrder + 1;
    const faces = [
        { key: 'front', position: [0, 0, label.faceDepths?.front ?? 0], rotation: [0, 0, 0] },
    ];
    if (label.doubleSidedReadable) {
        faces.push({ key: 'back', position: [0, 0, label.faceDepths?.back ?? 0.001], rotation: [0, Math.PI, 0] });
    }
    return {
        label, contentPosition: label.flag ? [width / 2, 0, 0] : label.position,
        background: label.background || label.flag ? {
            width, height, color: label.background?.color ?? label.color,
            opacity: label.background?.opacity ?? label.opacity * 0.8, position: [0, 0, -0.001],
        } : null,
        faces,
        textRenderOrder, initialTextOpacity: label.flag ? 0 : label.opacity,
        border: label.flag ? { points: [
                [-width / 2, -height / 2, 0], [width / 2, -height / 2, 0],
                [width / 2, height / 2, 0], [-width / 2, height / 2, 0], [-width / 2, -height / 2, 0],
            ], renderOrder: textRenderOrder ?? 0 } : null,
        post: post ? { points: [post, [post[0] * postTopScale, post[1] * postTopScale, post[2] * postTopScale]],
            ...(label.flag?.prongOffsets ? { prongs: label.flag.prongOffsets.flatMap(offset => [post, [post[0] + offset[0], post[1] + offset[1], post[2] + offset[2]]]) } : {}),
            renderOrder: label.renderOrder ?? 0 } : null,
    };
}
export function resolveLabelFramePresentation(args) {
    const { label, proximity, cameraProximityFade, labelDistance, itemDistance, projectedFontPixels } = args;
    let factor = proximity === undefined || label.flag ? 1
        : resolveLabelProximityOpacity({ distance: labelDistance, fontSize: label.fontSize, proximity });
    if (cameraProximityFade && itemDistance !== undefined) {
        factor *= resolveCameraProximityOpacity({
            proximity: { distance: itemDistance, inside: itemDistance === 0 }, fade: cameraProximityFade,
        });
    }
    return { visible: factor > 0.01, backgroundFactor: factor,
        textFactor: factor * (label.flag ? resolveFlagTextOpacity(projectedFontPixels, label.flag.minTextPixels) : 1) };
}
